export enum FeedType {
	DIRECT = 'DIRECT',
	FOLLOWING = 'FOLLOWING',
	POPULAR = 'POPULAR',
}
